/** @prettier */
import { List } from 'immutable';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';

import RelatedEvent from '../../../containers/SingleEventPage/RelatedEvents/RelatedEvent';

import styles from './RelatedEvents.module.scss';

const EMPTY_LIST = new List();

export default function RelatedEvents({
  tag,
  eventId,
  product,
  relatedEvents = EMPTY_LIST,
  requestRelatedEvents,
}) {
  const onEventClose = useCallback(() => {
    requestRelatedEvents(null, tag);
  }, [tag]);

  useEffect(() => {
    requestRelatedEvents(eventId, tag);
  }, [tag]);

  if (relatedEvents.size < 2) return null;

  return (
    <div className={styles.main}>
      <h4 className={styles.title}>Related Events</h4>
      <ul className={styles.list}>
        {relatedEvents.slice(0, 5).map((event) => (
          <RelatedEvent
            key={event.id}
            event={event}
            product={product}
            selectedEvent={eventId}
            onEventClose={onEventClose}
          />
        ))}
      </ul>
    </div>
  );
}

RelatedEvents.propTypes = {
  tag: PropTypes.string,
  eventId: PropTypes.string,
  product: PropTypes.string.isRequired,
  requestRelatedEvents: PropTypes.func,
  relatedEvents: PropTypes.instanceOf(List),
};
